import { MFCentralStatus, MfCentralRefetchInterval } from "../types";

export const MFCENTRAL_IN_PROGESS_STATUS: MFCentralStatus[] = [
  "OTP_VERIFIED",
  "FILE_RECEIVED",
];

export const mfCentralRefetchInterval: MfCentralRefetchInterval = (query) => {
  const { data } = query.state;
  if (data?.status && MFCENTRAL_IN_PROGESS_STATUS.includes(data?.status))
    return 5000;
  return false;
};

export type ImportState = "idle" | "in-progress" | "expired";
